<template>
<div>
  <span>如果您未能接受到邮件，建议您：</span>
  <span>1）查看被拦截邮件或垃圾邮箱</span>
  <span>2）更换其他电子邮箱尝试</span>
  <span>3）联系我们（contact@51xueshuo.com）</span>
</div>
</template>

<script>
export default {
  methods:{
    sendAgain(){
      this.$emit("againFunc")
    }
  }
}
</script>

<style scoped lang="scss">
  span{
    display: block;
    margin-top: 5px;
  }
</style>
